export default __webpack_public_path__ + "static/media/Promocao-indica-mais.cf996182.png";